module.exports = __webpack_public_path__ + "static/media/investor-discovery.8d3787aa.svg";